import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-packing",
  "use": "icon-packing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-packing\"><path d=\"M923.92 63.95H99.71A35.7 35.7 0 0 0 64 99.65v824.21a35.7 35.7 0 0 0 35.7 35.7h824.22a35.7 35.7 0 0 0 35.7-35.7V99.65a35.7 35.7 0 0 0-35.7-35.7z m-521.37 57.28h221V340.3h-221z m499.79 781h-781v-781h224v240.84a35.52 35.52 0 0 0 35.52 35.52h264.5a35.52 35.52 0 0 0 35.52-35.52V121.23h221.46z\" p-id=\"4974\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol